import { createApp } from 'vue';
import App from '../src/App.vue';
import router from '../src/router.js';
import VueTheMask from 'vue-the-mask';1
import { app } from "../src/firebase";
import { getAuth } from "firebase/auth";
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import 'vuetify/styles'; // Global CSS
import '@mdi/font/css/materialdesignicons.css'; // Icons

const vuetify = createVuetify({
  components,
  directives,
});

const auth = getAuth(app);

createApp(App)
    .use(router)
    .use(vuetify)
    .use(VueTheMask)
    .mount('#app');
